const state = {
  activeTab: 0
}

const mutations = {
  SET_ACTIVE_TAB: (state, activeTab) => {
    state.activeTab = activeTab
  }
}

const actions = {
  setActiveTab({ commit }, activeTab) {
    commit('SET_ACTIVE_TAB', activeTab)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
